var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWrench(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "build_24px"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon/action/build_24px",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5759 9.90957L22.6559 18.9896C23.0559 19.3896 23.0559 20.0196 22.6559 20.3996L20.3559 22.6996C19.9659 23.0896 19.3359 23.0896 18.9459 22.6996L9.83586 13.5896C7.51586 14.4596 4.80586 13.9696 2.94586 12.1096C0.64586 9.81957 0.43586 6.22957 2.29586 3.68957L6.12586 7.51957L7.54586 6.10957L3.70586 2.25957C6.25586 0.399574 9.83586 0.609574 12.1359 2.90957C14.0259 4.80957 14.5059 7.56957 13.5759 9.90957ZM10.1959 11.1296L19.6559 20.5896L20.5359 19.6996L11.0859 10.2496C11.5459 9.65957 11.8459 8.99957 11.9659 8.28957C12.2159 6.89957 11.8059 5.40957 10.7259 4.32957C9.77586 3.38957 8.52586 2.94957 7.28586 3.01957L10.3759 6.10957L6.13586 10.3496L3.04586 7.25957C2.97586 8.49957 3.41586 9.75957 4.36586 10.6996C5.40586 11.7396 6.83586 12.1496 8.19586 11.9496C8.90586 11.8496 9.58586 11.5796 10.1959 11.1296Z",
    fill: "black",
    fillOpacity: 0.54
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrench);
export default __webpack_public_path__ + "static/media/wrench.3c595c66efe2deef45f5bd6dcb34dd0b.svg";
export { ForwardRef as ReactComponent };